'use strict'

import { useState } from 'react'

const NAV_ICONS = {
  properties: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>,
  map: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" viewBox="0 0 24 24"><path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/></svg>,
  compare: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" viewBox="0 0 24 24"><path d="M8 7h12M8 12h12M8 17h12M4 7h.01M4 12h.01M4 17h.01"/></svg>,
  anchors: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" viewBox="0 0 24 24"><path d="M12 8a2 2 0 100-4 2 2 0 000 4zm0 0v12m-7-5a7 7 0 0014 0"/></svg>,
  routes: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" viewBox="0 0 24 24"><path d="M13 17l5-5-5-5M6 17l5-5-5-5"/></svg>,
  back: <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>,
  caret: <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>,
  warn: <svg width="12" height="12" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd"/></svg>,
  check: <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>,
  cut: <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.7" viewBox="0 0 24 24"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12"/></svg>,
  trash: <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.7" viewBox="0 0 24 24"><path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
}

const STATUS_DOT = { draft: '#c66a45', published: '#1f5e3a', archived: '#97a094' }
const STATUS_LABEL = { draft: 'Draft', published: 'Published', archived: 'Archived' }

const NAV_ITEMS = [
  { id: 'properties', label: 'Properties' },
  { id: 'map',        label: 'Map' },
  { id: 'compare',    label: 'Compare' },
  { id: 'anchors',    label: 'Anchors' },
  { id: 'routes',     label: 'Routes' }
]

export default function SidebarNav ({
  scenarios,
  selectedScenario,
  selectedScenarioId,
  onScenarioChange,
  onBack,
  currentTab,
  onTabChange,
  onCutCrew,
  onDelete,
  cutCrewDisabled,
  staleFreshness,
  anchorBadge
}) {
  const [pickerOpen, setPickerOpen] = useState(false)
  const isDraft = selectedScenario?.status === 'draft'
  const dotColor = STATUS_DOT[selectedScenario?.status] || '#97a094'

  return (
    <div className="sidebar">
      <button
        onClick={onBack}
        style={{
          display: 'flex', alignItems: 'center', gap: 8, padding: '12px 14px',
          color: 'var(--df-nav-ink-2)', background: 'none', border: 'none', cursor: 'pointer',
          fontSize: 12, fontWeight: 600, width: '100%', textAlign: 'left',
          borderBottom: '1px solid var(--df-nav-border)', transition: 'color 0.12s'
        }}
        onMouseEnter={e => { e.currentTarget.style.color = 'var(--df-nav-ink)' }}
        onMouseLeave={e => { e.currentTarget.style.color = 'var(--df-nav-ink-2)' }}
      >
        {NAV_ICONS.back}
        <span>All Scenarios</span>
      </button>

      {selectedScenario && (
        <div className="ctx-block">
          <div className="ctx-scenario" onClick={() => setPickerOpen(o => !o)}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: dotColor, flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="ctx-name" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {selectedScenario.name}
              </div>
              <div className="ctx-sub">
                {STATUS_LABEL[selectedScenario.status] || selectedScenario.status} · {selectedScenario.assignmentCount || 0} overrides
              </div>
            </div>
            <div style={{ color: 'var(--df-nav-ink-3)', display: 'flex', flexShrink: 0 }}>{NAV_ICONS.caret}</div>
          </div>

          {pickerOpen && (
            <div style={{ marginTop: 8, background: '#1a2c1f', borderRadius: 8, overflow: 'hidden' }}>
              {scenarios.map(s => (
                <div
                  key={s._id}
                  onClick={() => { onScenarioChange(s._id); setPickerOpen(false) }}
                  style={{
                    padding: '8px 10px', cursor: 'pointer', display: 'flex', gap: 7, alignItems: 'center',
                    background: s._id === selectedScenarioId ? 'var(--df-nav-active)' : 'transparent',
                    transition: 'background 0.1s'
                  }}
                  onMouseEnter={e => { if (s._id !== selectedScenarioId) e.currentTarget.style.background = 'var(--df-nav-hover)' }}
                  onMouseLeave={e => { if (s._id !== selectedScenarioId) e.currentTarget.style.background = 'transparent' }}
                >
                  <div style={{ width: 7, height: 7, borderRadius: '50%', background: STATUS_DOT[s.status] || '#97a094', flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--df-nav-ink)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.name}</div>
                    <div style={{ fontSize: 10, color: 'var(--df-nav-ink-3)' }}>{STATUS_LABEL[s.status]}</div>
                  </div>
                  {s._id === selectedScenarioId && <div style={{ color: 'var(--df-nav-bar)', display: 'flex' }}>{NAV_ICONS.check}</div>}
                </div>
              ))}
            </div>
          )}

          {staleFreshness && (
            <div style={{
              marginTop: 8, padding: '6px 8px', background: 'rgba(198,106,69,0.12)',
              borderRadius: 6, border: '1px solid rgba(198,106,69,0.2)',
              display: 'flex', gap: 5, alignItems: 'flex-start'
            }}>
              <span style={{ color: 'var(--df-accent)', display: 'flex', flexShrink: 0, marginTop: 1 }}>{NAV_ICONS.warn}</span>
              <span style={{ fontSize: 11, color: 'var(--df-accent)', lineHeight: 1.35 }}>
                Routing sync is stale. Consider re-syncing before publishing.
              </span>
            </div>
          )}
        </div>
      )}

      <div className="nav-section">
        {NAV_ITEMS.map(n => (
          <div
            key={n.id}
            className={`nav-item${currentTab === n.id ? ' active' : ''}`}
            onClick={() => onTabChange(n.id)}
          >
            <span className="nav-icon">{NAV_ICONS[n.id]}</span>
            <span>{n.label}</span>
            {n.id === 'anchors' && anchorBadge > 0 && (
              <span className="nav-badge warn">{anchorBadge}</span>
            )}
          </div>
        ))}
      </div>

      <div style={{ flex: 1 }} />

      <div style={{ padding: '12px 10px', borderTop: '1px solid var(--df-nav-border)', display: 'flex', flexDirection: 'column', gap: 4 }}>
        <button
          style={{
            display: 'flex', alignItems: 'center', gap: 7, padding: '7px 8px', borderRadius: 6,
            border: 'none', background: 'none', color: 'var(--df-nav-ink-2)', cursor: cutCrewDisabled ? 'not-allowed' : 'pointer',
            fontSize: 12, fontWeight: 500, width: '100%', transition: 'all 0.12s',
            opacity: cutCrewDisabled ? 0.4 : 1
          }}
          onClick={onCutCrew}
          disabled={cutCrewDisabled}
          onMouseEnter={e => { if (!cutCrewDisabled) e.currentTarget.style.color = 'var(--df-nav-ink)' }}
          onMouseLeave={e => { e.currentTarget.style.color = 'var(--df-nav-ink-2)' }}
        >
          {NAV_ICONS.cut}<span>Cut Crew</span>
        </button>
        {isDraft && (
          <button
            style={{
              display: 'flex', alignItems: 'center', gap: 7, padding: '7px 8px', borderRadius: 6,
              border: 'none', background: 'none', color: 'var(--df-nav-ink-2)', cursor: 'pointer',
              fontSize: 12, fontWeight: 500, width: '100%', transition: 'all 0.12s'
            }}
            onClick={onDelete}
            onMouseEnter={e => { e.currentTarget.style.color = 'var(--df-accent)' }}
            onMouseLeave={e => { e.currentTarget.style.color = 'var(--df-nav-ink-2)' }}
          >
            {NAV_ICONS.trash}<span>Delete Scenario</span>
          </button>
        )}
      </div>
    </div>
  )
}
